import { FC } from 'react';

export const ILSCellAntd: FC = ({ children }) => {
  return <>{children}</>;
};
